<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">
    {{ 'transfer.playerByCode' | translate }}
  </h5>
  <button type="button" class="btn-close" [disabled]="isSubmitting" (click)="closeModal()"></button>
</div>

<form [formGroup]="transferForm" class="form theme-form" (ngSubmit)="submitForm()">
  <div class="modal-body">
    <div class="row justify-content-center mb-3">
      <div class="col-12 col-sm-auto">
        <div
          class="toggle-button-group d-flex align-items-stretch position-relative w-100 w-sm-auto overflow-hidden"
          role="group"
          aria-label="Basic radio toggle button group">
          <input
            type="radio"
            class="btn-check"
            name="btnradio"
            id="btnradio1"
            autocomplete="off"
            [disabled]="isSubmitting"
            (change)="onOptionChange(TYPE_TRANSACTIONS.DEPOSIT)"
            [checked]="transaction_type === TYPE_TRANSACTIONS.DEPOSIT" />
          <label
            class="btn-custom text-secondary fw-bold text-center d-flex align-items-center justify-content-center w-50 h-100 lh-1 py-2"
            for="btnradio1"
            [ngClass]="{ 'text-white': transaction_type === TYPE_TRANSACTIONS.DEPOSIT }">
            {{ 'words.deposit' | translate }}
          </label>

          <input
            type="radio"
            class="btn-check"
            name="btnradio"
            id="btnradio2"
            autocomplete="off"
            [disabled]="isSubmitting"
            (change)="onOptionChange(TYPE_TRANSACTIONS.WITHDRAWAL)"
            [checked]="transaction_type === TYPE_TRANSACTIONS.WITHDRAWAL" />
          <label
            class="btn-custom text-secondary fw-bold text-center d-flex align-items-center justify-content-center w-50 h-100 lh-1 py-2"
            for="btnradio2"
            [ngClass]="{ 'text-white': transaction_type === TYPE_TRANSACTIONS.WITHDRAWAL }">
            {{ 'words.withdrawal' | translate }}
          </label>

          <div class="glider"></div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      @if (transaction_type === TYPE_TRANSACTIONS.DEPOSIT) {
        <div class="form-group col-6" appRequiredAsterisk>
          <label for="playerCode" class="form-label">
            {{ 'transfer.playerCode' | translate }}
          </label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              formControlName="playerCode"
              placeholder="{{ 'transfer.placeholders.playerCode' | translate }}"
              (paste)="onCodePaste($event, 'playerCode')"
              onlyNumbers
              maxlength="15"
              id="playerCode" />
            <button
              type="button"
              class="btn btn-outline-secondary"
              ngbTooltip="{{ 'transfer.scanQr' | translate }}"
              [disabled]="isLookingUpCode || isSubmitting"
              (click)="openQrScanner('playerCode')">
              <i
                class="fa"
                [class.fa-qrcode]="!isLookingUpCode"
                [class.fa-spinner]="isLookingUpCode"
                [class.fa-spin]="isLookingUpCode"></i>
            </button>
          </div>
        </div>
      } @else {
        <div class="form-group col-6" appRequiredAsterisk>
          <label for="withdrawalCode" class="form-label">
            {{ 'transfer.withdrawalCode' | translate }}
          </label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              formControlName="withdrawalCode"
              placeholder="{{ 'transfer.placeholders.withdrawalCode' | translate }}"
              (paste)="onCodePaste($event, 'withdrawalCode')"
              maxlength="15"
              id="withdrawalCode" />
            <button
              type="button"
              class="btn btn-outline-secondary"
              ngbTooltip="{{ 'transfer.scanQr' | translate }}"
              [disabled]="isLookingUpCode || isSubmitting"
              (click)="openQrScanner('withdrawalCode')">
              <i
                class="fa"
                [class.fa-qrcode]="!isLookingUpCode"
                [class.fa-spinner]="isLookingUpCode"
                [class.fa-spin]="isLookingUpCode"></i>
            </button>
          </div>
        </div>
      }

      @if (transaction_type === TYPE_TRANSACTIONS.DEPOSIT) {
        <div class="form-group col-6" appRequiredAsterisk>
          <label for="amount" class="form-label">
            {{ 'transfer.amount' | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            appOnlyNumbersWhitTwoDecimal
            formControlName="amount"
            placeholder="0.00"
            required
            id="amount" />
        </div>
      } @else {
        <div class="form-group col-6">
          <label class="form-label">{{ 'transfer.amount' | translate }}</label>
          <input
            type="text"
            class="form-control"
            [value]="resolvedWithdrawalAmount ?? ('transfer.pendingLookup' | translate)"
            disabled />
        </div>
      }
    </div>

    @if (isLookingUpCode) {
      <div class="small text-secondary mb-2">
        <i class="fa fa-spinner fa-spin"></i>
        {{
          (transaction_type === TYPE_TRANSACTIONS.DEPOSIT
            ? 'transfer.lookingUpPlayer'
            : 'transfer.lookingUpWithdrawalCode'
          ) | translate
        }}
      </div>
    }

    @if (resolvedPlayerId) {
      <div class="card bg-light-secondary mb-2">
        <div class="card-body py-2 px-3">
          <div class="fw-semibold">{{ resolvedPlayerFullName }}</div>
          <div class="small text-secondary">
            {{ resolvedPlayerUsername }} · {{ 'financial.holders.documentNumber' | translate }}:
            {{ resolvedPlayerDocumentNumber }}
          </div>
        </div>
      </div>
    }

    <div class="row mt-2">
      <div class="form-group col-md-12">
        <label for="comment" class="form-label">
          {{ 'transfer.comentary' | translate }}
        </label>
        <input
          type="text"
          class="form-control"
          formControlName="comment"
          placeholder="{{ 'transfer.placeholders.writeComentary' | translate }}"
          id="comment" />
      </div>
    </div>

    @if (transaction_type === TYPE_TRANSACTIONS.DEPOSIT) {
      <div class="media m-1 label-switch-grid">
        <label class="col-form-label">
          {{ 'transfer.transferCash' | translate }}
        </label>

        <div class="media-body switch-sm">
          <label class="x-switch">
            <input
              type="checkbox"
              [disabled]="isSubmitting"
              (change)="toggleBankingMode()"
              [checked]="isBanking" />
            <span class="x-switch__state"></span>
          </label>

          <span class="font-roboto">
            {{ isBanking ? ('transfer.banking' | translate) : ('transfer.direct' | translate) }}
          </span>
        </div>
      </div>

      <div class="slide-container" [ngClass]="{ visible: isBanking }">
        <div class="row justify-content-center">
          <div class="col-lg-8 col-md-10">
            <div class="form-group mb-2" appRequiredAsterisk>
              <label for="bankId" class="form-label">
                {{ 'financial.holders.bankName' | translate }}
              </label>
              <ng-select
                id="bankId"
                formControlName="bankId"
                bindLabel="label"
                bindValue="value"
                placeholder="{{ 'financial.holders.bankName' | translate }}"
                [items]="banks$ | async"
                (search)="onSearchSelect(NG_SELECT_QUERIES.BANKS, $event.term)"
                (clear)="onSearchSelect(NG_SELECT_QUERIES.BANKS)"
                (close)="onSearchSelect(NG_SELECT_QUERIES.BANKS)"
                (scrollToEnd)="onScrollToEndSelect(NG_SELECT_QUERIES.BANKS)"></ng-select>
            </div>

            <div class="form-group" appRequiredAsterisk>
              <label class="form-label">
                {{ 'transfer.receipt' | translate }}
              </label>
              <div
                class="card rounded p-3 text-center d-flex flex-column justify-content-center align-items-center cursor-pointer drop-area-container"
                (click)="!isSubmitting && triggerFileInput()"
                (dragover)="onDragOver($event)"
                (drop)="!isSubmitting && onDrop($event)">
                <input
                  type="file"
                  class="d-none"
                  formControlName="receipt"
                  accept="image/png,image/jpeg"
                  (change)="onFileSelected($event)"
                  #fileInput />
                @if (!previewImage) {
                  <ng-container>
                    <i class="fa fa-cloud-upload text-secondary mb-3 fs-1"></i>
                    <div class="text-light-emphasis">
                      {{ 'transfer.uploadReceipt' | translate }}
                    </div>
                  </ng-container>
                } @else {
                  <ng-container>
                    <img
                      [src]="previewImage"
                      alt="Vista Previa"
                      class="img-fluid preview-img rounded-3" />
                  </ng-container>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" [disabled]="isSubmitting" (click)="closeModal()">
      {{ 'btn.cancel' | translate }}
    </button>

    <button
      type="submit"
      class="btn btn-secondary"
      [disabled]="
        isSubmitting ||
        transferForm.invalid ||
        !resolvedPlayerId ||
        (isBanking && (!transferForm.value.bankId || selectedFiles.length === 0))
      ">
      @if (isSubmitting) {
        <i class="fa fa-spinner fa-spin"></i>
      }
      {{ getButtonLabel() | translate }}
    </button>
  </div>
</form>
